import * as yup from 'yup'

export const SignUpValidationScheme = yup.object().shape({
  email: yup
    .string()
    .email('Email Address is invalid')
    .max(100)
    .required('The field is required'),
  password: yup
    .string()
    .max(256, 'Password has a maximum of 256 characters'),
  confirmPassword: yup
    .string()
    .when('password', {
      is: (password) => !!(password && password.length > 0),
      then: yup
        .string()
        .required('Please confirm your password')
        .oneOf([yup.ref('password')], 'Passwords do not match'),
      otherwise: yup.string().notRequired()
    })
})
